module.exports = __webpack_public_path__ + "2e45e53b736a2df8c757d1483cc0e237.jpg";